import { render } from "./GameTitle.vue?vue&type=template&id=74366946&scoped=true"
import script from "./GameTitle.vue?vue&type=script&lang=js"
export * from "./GameTitle.vue?vue&type=script&lang=js"

import "./GameTitle.vue?vue&type=style&index=0&id=74366946&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74366946"]])

export default __exports__